import { NotificationContainer } from "react-notifications";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import { WPToastNotification } from "./packages/WPToastNotification";

import { UnsavedChangesProvider } from "./hooks/useUnsavedChanges";

import { router } from "./Routes.js";

import CAStore from "./Store/TemplateStore/template.store";

import "./styles/vendors/style.js";

export const store = CAStore;

// Commented out to avoid showing a browser leave/refresh confirmation on navigation; uncomment only when browser-level confirmation on navigation is required.
// window.onbeforeunload = (event) => {
//   event.preventDefault();
//   event.returnValue = "";
// };

function App() {
  return (
    <Provider store={store}>
      <UnsavedChangesProvider>
        <RouterProvider router={router} />
      </UnsavedChangesProvider>

      <NotificationContainer />
      <WPToastNotification />
    </Provider>
  );
}

export default App;
